import React, { useState } from 'react';
import { TextField, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import type { FormData, BulkDiscount } from '../../../types';

const BulkDiscountFields: React.FC<{
	formData: FormData;
	setFormData: React.Dispatch<React.SetStateAction<FormData>>;
	disabled?: boolean;
}> = ({ formData, setFormData, disabled }) => {
	const [bulkDiscountField, setBulkDiscountField] = useState<BulkDiscount>({
		minQuantity: 1,
		maxQuantity: 1,
		discountPercentage: 1,
	});

	const handleAddBulkDiscountField = () => {
		if (bulkDiscountField.maxQuantity <= bulkDiscountField.minQuantity) {
			toast.error('Maximum Quantity must be greater than Minimum Quantity');
			return;
		}

		setFormData((prev) => ({
			...prev,
			buldDiscountsData: [...prev.buldDiscountsData, bulkDiscountField],
		}));

		setBulkDiscountField({
			minQuantity: 1,
			maxQuantity: 1,
			discountPercentage: 1,
		});
	};

	const handleDeleteBulkDiscountField = (index: number) => {
		setFormData((prev) => ({
			...prev,
			buldDiscountsData: prev.buldDiscountsData.filter((_, i) => i !== index),
		}));
	};

	const handleBulkDiscountFieldChange = (
		index: number,
		field: keyof BulkDiscount,
		value: any
	) => {
		const newBulkDiscountsData = [...formData.buldDiscountsData];
		if (field === 'maxQuantity' && Number(value) <= newBulkDiscountsData[index].minQuantity) {
			toast.error('Maximum Quantity must be greater than Minimum Quantity');
			return;
		}
		newBulkDiscountsData[index][field] = value;
		setFormData((prev) => ({ ...prev, buldDiscountsData: newBulkDiscountsData }));
	};

	return (
		<>
			{formData.buldDiscountsData.length > 0 &&
				formData.buldDiscountsData.map((val, index) => (
					<React.Fragment key={index}>
						<Grid size={{ xs: 12, sm: 6, md: 4 }}>
							<TextField
								sx={{
									margin: 0,
									'& .MuiFormControlLabel-label': {
										fontSize: { xs: '14px', sm: '16px', md: '18px' }, // responsive font size
									},
								}}
								size="small"
								label="Minimum Quantity"
								name="minQuantity"
								type="number"
								disabled={disabled}
								value={val.minQuantity}
								onChange={(e) =>
									handleBulkDiscountFieldChange(
										index,
										'minQuantity',
										e.target.value
									)
								}
								required
								fullWidth
								margin="normal"
								inputProps={{ min: '1' }}
							/>
						</Grid>
						<Grid size={{ xs: 12, sm: 6, md: 4 }}>
							<TextField
								sx={{ margin: '0px' }}
								size="small"
								label="Maximum Quantity"
								name="maxQuantity"
								type="number"
								value={val.maxQuantity}
								onChange={(e) =>
									handleBulkDiscountFieldChange(
										index,
										'maxQuantity',
										e.target.value
									)
								}
								required
								fullWidth
								margin="normal"
								inputProps={{ min: '1' }}
								disabled={disabled}
							/>
						</Grid>
						<Grid size={{ xs: 9, sm: 9, md: 3 }}>
							<TextField
								sx={{ margin: '0px' }}
								size="small"
								disabled={disabled}
								label="Discount Percentage"
								name="discountPercentage"
								type="number"
								value={val.discountPercentage}
								onChange={(e) =>
									handleBulkDiscountFieldChange(
										index,
										'discountPercentage',
										e.target.value
									)
								}
								required
								fullWidth
								margin="normal"
								inputProps={{ min: '1' }}
							/>
						</Grid>
						<Grid size={{ xs: 3, sm: 3, md: 1 }}>
							<IconButton
								disabled={disabled}
								aria-label="Delete"
								onClick={() => handleDeleteBulkDiscountField(index)}
							>
								<DeleteIcon />
							</IconButton>
						</Grid>
					</React.Fragment>
				))}

			<React.Fragment>
				<Grid size={{ xs: 12, sm: 6, md: 4 }}>
					<TextField
						sx={{ margin: '0px' }}
						size="small"
						label="Minimum Quantity"
						name="minQuantity"
						type="number"
						disabled={disabled}
						value={bulkDiscountField.minQuantity}
						onChange={(e) =>
							setBulkDiscountField((prev) => ({
								...prev,
								minQuantity: Number(e.target.value),
							}))
						}
						required
						fullWidth
						margin="normal"
						inputProps={{ min: '1' }}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 6, md: 4 }}>
					<TextField
						sx={{ margin: '0px' }}
						size="small"
						label="Maximum Quantity"
						name="maxQuantity"
						type="number"
						disabled={disabled}
						value={bulkDiscountField.maxQuantity}
						onChange={(e) =>
							setBulkDiscountField((prev) => ({
								...prev,
								maxQuantity: Number(e.target.value),
							}))
						}
						required
						fullWidth
						margin="normal"
						inputProps={{ min: '1' }}
					/>
				</Grid>
				<Grid size={{ xs: 9, sm: 9, md: 3 }}>
					<TextField
						sx={{ margin: '0px' }}
						size="small"
						label="Discount Percentage"
						name="discountPercentage"
						type="number"
						disabled={disabled}
						value={bulkDiscountField.discountPercentage}
						onChange={(e) =>
							setBulkDiscountField((prev) => ({
								...prev,
								discountPercentage: Number(e.target.value),
							}))
						}
						required
						fullWidth
						margin="normal"
						inputProps={{ min: '1' }}
					/>
				</Grid>
				<Grid size={{ xs: 3, sm: 3, md: 1 }}>
					<IconButton
						aria-label="Add"
						onClick={handleAddBulkDiscountField}
						disabled={disabled}
					>
						<AddCircleIcon />
					</IconButton>
				</Grid>
			</React.Fragment>
		</>
	);
};

export default BulkDiscountFields;
